<button (click)="enforce()" [disabled]="isSubmitting" class="button-black">
  <div class="icon">
    <img [src]="isEnforceSubmitting ? '/assets/spinner.svg' : '/assets/enforce.svg'" [ngClass]="{ 'spinned': isEnforceSubmitting, 'withheld': isSubmitting && !isEnforceSubmitting }">
  </div>
  Претензия
</button>

<button (click)="purchase()" [disabled]="isSubmitting" class="button-black">
  <div class="icon">
    <img [src]="isPurchaseSubmitting ? '/assets/spinner.svg' : '/assets/cart.svg'" [ngClass]="{ 'spinned': isPurchaseSubmitting, 'withheld': isSubmitting && !isPurchaseSubmitting  }">
  </div>
  Закупка
</button>
